import React from "react";
import PropTypes from "prop-types";

import {
  ReactDefaultPropsWithChildren,
  ReactComponentStaticProps,
} from "../../types/react";
import { Modal } from "../Modal";

import styles from "./DateRangePicker.scss";

type ModalFrameBaseProps = {
  displayDatePicker: boolean;
  hidePicker: () => void;
};

type ModalFrameProps = React.PropsWithChildren<ModalFrameBaseProps>;

const defaultProps = {
  children: undefined,
} as const;

const validatedDefaultProps: ReactDefaultPropsWithChildren<
  ModalFrameProps,
  typeof defaultProps
> = defaultProps;

export const ModalFrame: ((props: ModalFrameProps) => JSX.Element) &
  ReactComponentStaticProps<ModalFrameProps> = ({
  displayDatePicker,
  hidePicker,
  children,
}) => {
  return (
    <Modal isOpen={displayDatePicker} afterClose={hidePicker} zIndex={10}>
      <Modal.Section customClass={styles["modal-section"]}>
        {children}
      </Modal.Section>
    </Modal>
  );
};

ModalFrame.propTypes = {
  displayDatePicker: PropTypes.bool.isRequired,
  hidePicker: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

ModalFrame.defaultProps = validatedDefaultProps;

ModalFrame.displayName = "DateRangePicker.ModalFrame";

export default ModalFrame;
